__turbopack_context__.v({
  "rotate360": "styles-module__2_X51q__rotate360",
  "spinner": "styles-module__2_X51q__spinner",
});
